import React from "react";
import { useSearchParams } from "react-router-dom";
import { auth } from "../services/api";

const ERRORS = {
  domain_not_allowed: "هذا البريد ليس على نطاق مسموح (rael.com.sa أو almacapital.com.sa)",
  deactivated: "حسابك موقوف — تواصل مع مدير النظام",
  not_allowed: "تعذّر الدخول بهذا الحساب",
  session_ended: "انتهت الجلسة — سجّل الدخول من جديد",
  server_error: "خطأ في الخادم أثناء الدخول — حاول مجددًا",
  login_failed: "تعذّر إتمام الدخول",
};

export default function LoginPage() {
  const [sp] = useSearchParams();
  const err = sp.get("error");
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(160deg,#02100F,#0f4c4b)", direction: "rtl", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: "36px 32px", width: "100%", maxWidth: 420, textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,.35)" }}>
        <img src="/logo-colored.svg" alt="Alma Capital" style={{ height: 56, marginBottom: 12 }} onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <div style={{ fontWeight: 900, fontSize: 20 }}>ألما المالية — نظام الإدارة</div>
        <div style={{ color: "#64748b", fontSize: 12.5, marginTop: 4, marginBottom: 20 }}>Alma Capital — Management System</div>
        {err && <div style={{ background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: 10, padding: "8px 12px", fontSize: 12.5, marginBottom: 14 }}>{ERRORS[err] || err}</div>}
        <a href={auth.loginUrl} style={{ display: "inline-flex", alignItems: "center", gap: 10, background: "#0f766e", color: "#fff", padding: "12px 22px", borderRadius: 12, fontWeight: 800, textDecoration: "none", fontSize: 14 }}>
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#fff" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/></svg>
          تسجيل الدخول بحساب Google
        </a>
        <div style={{ color: "#94a3b8", fontSize: 11.5, marginTop: 16, lineHeight: 1.7 }}>الدخول متاح لحسابات Google على نطاقي rael.com.sa و almacapital.com.sa. أول دخول يُنشئ الحساب بدور «مشاهد»، ويرفعه مدير النظام عند الحاجة.</div>
      </div>
    </div>
  );
}
